import React, { useState } from 'react';
import { Row, Col, Card, Accordion } from 'react-bootstrap';

const yesNo = value => {
  return value ? 'Sí' : 'No';
};

const VoluntaryPrevisionShow = ({ voluntaryPrevision }) => {
  const {
    voluntaryPrevisionType,
    translatedVoluntaryPrevisionType,
    voluntaryPensionFundName,
    translatedUnitOfAccountVoluntary,
    parsedAgreedQuantity,
    contractNumber,
    translatedVoluntaryPensionFundType,
    translatedPaymentMethod,
    parsedEmployerContribution,
    taxReduction,
    voluntaryIdentificationNumber,
    voluntaryName,
    voluntaryLastName,
    voluntarySecondLastName,
    periodFrom,
    periodTo,
    translatedPersonalMovmentCode,
    parsedVoluntarySavingsAmount,
    periodNumber
  } = voluntaryPrevision;

  const previsionCollectiveApv = voluntaryPrevisionType === 'collective_apv';
  const previsionIndemnityEvent = voluntaryPrevisionType === 'indemnity_event';
  const previsionVoluntaryAffiliate = voluntaryPrevisionType === 'voluntary_affiliate';
  const previsionDepositAgreed = voluntaryPrevisionType === 'deposit_agreed' || voluntaryPrevisionType === 'count_two';
  const previsionApv = voluntaryPrevisionType === 'apv';

  return (
    <>
      {/* APV */}
      {previsionApv && (
        <>
          <Row className="mt-3">
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Tipo de Previsión Voluntaria:</span>
                <span className="line" />
                <span className={`answer ${!translatedVoluntaryPrevisionType ? 'text-grey' : ''}`}>
                  {translatedVoluntaryPrevisionType || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Institución:</span>
                <span className="line" />
                <span className={`answer ${!voluntaryPensionFundName ? 'text-grey' : ''}`}>
                  {voluntaryPensionFundName || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Unidad de Pago:</span>
                <span className="line" />
                <span className={`answer ${!translatedUnitOfAccountVoluntary ? 'text-grey' : ''}`}>
                  {translatedUnitOfAccountVoluntary?.toUpperCase() || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Cantidad Acordada:</span>
                <span className="line" />
                <span className={`answer ${!parsedAgreedQuantity ? 'text-grey' : ''}`}>
                  {parsedAgreedQuantity || 'No Aplica'}
                </span>
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">N° de Contrato:</span>
                <span className="line" />
                <span className={`answer ${!contractNumber ? 'text-grey' : ''}`}>{contractNumber || 'No Aplica'}</span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Régimen Tributario:</span>
                <span className="line" />
                <span className={`answer ${!translatedVoluntaryPensionFundType ? 'text-grey' : ''}`}>
                  {translatedVoluntaryPensionFundType || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Forma de Pago:</span>
                <span className="line" />
                <span className={`answer ${!translatedPaymentMethod ? 'text-grey' : ''}`}>
                  {translatedPaymentMethod || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3} />
          </Row>
        </>
      )}

      {/* Deposit Convenido */}
      {previsionDepositAgreed && (
        <Row className="mt-3">
          <Col md={3}>
            <div className="d-flex flex-column mb-3">
              <span className="type">Tipo de Previsión Voluntaria:</span>
              <span className="line" />
              <span className={`answer ${!translatedVoluntaryPrevisionType ? 'text-grey' : ''}`}>
                {translatedVoluntaryPrevisionType || 'No Aplica'}
              </span>
            </div>
          </Col>
          <Col md={3}>
            <div className="d-flex flex-column mb-3">
              <span className="type">Institución:</span>
              <span className="line" />
              <span className={`answer ${!voluntaryPensionFundName ? 'text-grey' : ''}`}>
                {voluntaryPensionFundName || 'No Aplica'}
              </span>
            </div>
          </Col>
          <Col md={3}>
            <div className="d-flex flex-column mb-3">
              <span className="type">Unidad de Pago:</span>
              <span className="line" />
              <span className={`answer ${!translatedUnitOfAccountVoluntary ? 'text-grey' : ''}`}>
                {translatedUnitOfAccountVoluntary?.toUpperCase() || 'No Aplica'}
              </span>
            </div>
          </Col>
          <Col md={3}>
            <div className="d-flex flex-column mb-3">
              <span className="type">Cantidad Acordada:</span>
              <span className="line" />
              <span className={`answer ${!parsedAgreedQuantity ? 'text-grey' : ''}`}>
                {parsedAgreedQuantity || 'No Aplica'}
              </span>
            </div>
          </Col>
        </Row>
      )}

      {/* Collective APV */}
      {previsionCollectiveApv && (
        <>
          <Row className="mt-3">
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Tipo de Previsión Voluntaria:</span>
                <span className="line" />
                <span className={`answer ${!translatedVoluntaryPrevisionType ? 'text-grey' : ''}`}>
                  {translatedVoluntaryPrevisionType || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Institución:</span>
                <span className="line" />
                <span className={`answer ${!voluntaryPensionFundName ? 'text-grey' : ''}`}>
                  {voluntaryPensionFundName || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Unidad de Pago:</span>
                <span className="line" />
                <span className={`answer ${!translatedUnitOfAccountVoluntary ? 'text-grey' : ''}`}>
                  {translatedUnitOfAccountVoluntary?.toUpperCase() || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Aporte Trabajador:</span>
                <span className="line" />
                <span className={`answer ${!parsedAgreedQuantity ? 'text-grey' : ''}`}>
                  {parsedAgreedQuantity || 'No Aplica'}
                </span>
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Aporte Empleador:</span>
                <span className="line" />
                <span className={`answer ${!parsedEmployerContribution ? 'text-grey' : ''}`}>
                  {parsedEmployerContribution || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">N° de Contrato:</span>
                <span className="line" />
                <span className={`answer ${!contractNumber ? 'text-grey' : ''}`}>{contractNumber || 'No Aplica'}</span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Forma de Pago:</span>
                <span className="line" />
                <span className={`answer ${!translatedPaymentMethod ? 'text-grey' : ''}`}>
                  {translatedPaymentMethod || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Rebaja de la Base Tributaria:</span>
                <span className="line" />
                <span className="answer">{yesNo(taxReduction)}</span>
              </div>
            </Col>
          </Row>
        </>
      )}

      {/* Voluntary Affiliate */}
      {previsionVoluntaryAffiliate && (
        <>
          <Row className="mt-3">
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Tipo de Previsión Voluntaria:</span>
                <span className="line" />
                <span className={`answer ${!translatedVoluntaryPrevisionType ? 'text-grey' : ''}`}>
                  {translatedVoluntaryPrevisionType || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Institución:</span>
                <span className="line" />
                <span className={`answer ${!voluntaryPensionFundName ? 'text-grey' : ''}`}>
                  {voluntaryPensionFundName || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Unidad de Pago:</span>
                <span className="line" />
                <span className={`answer ${!translatedUnitOfAccountVoluntary ? 'text-grey' : ''}`}>
                  {translatedUnitOfAccountVoluntary?.toUpperCase() || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Aporte Voluntario:</span>
                <span className="line" />
                <span className={`answer ${!parsedVoluntarySavingsAmount ? 'text-grey' : ''}`}>
                  {parsedVoluntarySavingsAmount || 'No Aplica'}
                </span>
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Rut:</span>
                <span className="line" />
                <span className={`answer ${!voluntaryIdentificationNumber ? 'text-grey' : ''}`}>
                  {voluntaryIdentificationNumber || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Nombre y Apellido:</span>
                <span className="line" />
                <span className={`answer ${!voluntaryName ? 'text-grey' : ''}`}>
                  {`${voluntaryName || ''} ${voluntaryLastName || ''} ${voluntarySecondLastName || ''}`.trim() ||
                    'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Fecha Desde:</span>
                <span className="line" />
                <span className={`answer ${!periodFrom ? 'text-grey' : ''}`}>{periodFrom || 'No Aplica'}</span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Fecha Hasta:</span>
                <span className="line" />
                <span className={`answer ${!periodTo ? 'text-grey' : ''}`}>{periodTo || 'No Aplica'}</span>
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Código Movimiento Personal:</span>
                <span className="line" />
                <span className={`answer ${!translatedPersonalMovmentCode ? 'text-grey' : ''}`}>
                  {translatedPersonalMovmentCode || 'No Aplica'}
                </span>
              </div>
            </Col>
          </Row>
        </>
      )}

      {/* Indemnity Event */}
      {previsionIndemnityEvent && (
        <>
          <Row className="mt-3">
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Tipo de Previsión Voluntaria:</span>
                <span className="line" />
                <span className={`answer ${!translatedVoluntaryPrevisionType ? 'text-grey' : ''}`}>
                  {translatedVoluntaryPrevisionType || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Institución:</span>
                <span className="line" />
                <span className={`answer ${!voluntaryPensionFundName ? 'text-grey' : ''}`}>
                  {voluntaryPensionFundName || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Periodo Desde:</span>
                <span className="line" />
                <span className={`answer ${!periodFrom ? 'text-grey' : ''}`}>{periodFrom || 'No Aplica'}</span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Periodo Hasta:</span>
                <span className="line" />
                <span className={`answer ${!periodTo ? 'text-grey' : ''}`}>{periodTo || 'No Aplica'}</span>
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Nº de Periodo:</span>
                <span className="line" />
                <span className={`answer ${!periodNumber ? 'text-grey' : ''}`}>
                  {voluntaryPrevision.periodNumber || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Tasa de Indemnización:</span>
                <span className="line" />
                <span className={`answer ${!voluntaryPrevision.parsedIndemnificationRate ? 'text-grey' : ''}`}>
                  {voluntaryPrevision.parsedIndemnificationRate || 'No Aplica'}
                </span>
              </div>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

const EmployeePrevisionInfo = ({ employeePrevisionAttributes = {}, contract }) => {
  const {
    fun,
    healthPrevision,
    heavyLaborStation,
    parsedAgreedQuantity,
    pensionScheme,
    pensionFund,
    pensionAffiliationDate,
    parsedPensionSchemeRate,
    parsedEvictionContributionRate,
    translatedIsOldAge,
    translatedHeavyLaborAdditional,
    translatedIneCode,
    translatedIpsType,
    translatedPensionScheme,
    translatedPensioner,
    translatedUnitOfAccount,
    unemploymentInsurance,
    voluntaryPrevisionsAttributes,
    youthAllowance
  } = employeePrevisionAttributes;

  const { disability, translatedDisability, disabilityFileInfo, disabilityNationalIdentification } = contract;
  const [activeKey, setKey] = useState('prev');
  let voluntaryPrevisions;
  if (voluntaryPrevisionsAttributes) {
    voluntaryPrevisions = voluntaryPrevisionsAttributes.map((voluntaryPrevision, index, arr) => {
      return (
        <>
          <VoluntaryPrevisionShow
            key={`voluntary_prevision_${index.toString()}`}
            voluntaryPrevision={voluntaryPrevision}
          />
          {index < arr.length - 1 && <hr className="my-4 mt-2" />}
        </>
      );
    });
  }

  return (
    <Accordion defaultActiveKey="0">
      <Card className="mt-3 ml-2 mr-2">
        <Col className={`${activeKey === 'prev' ? 'top-header-green' : 'top-header-light-gray'} br-5`}>
          <Accordion.Toggle
            as={Col}
            eventKey="0"
            className="card-header-title"
            onClick={() => setKey('prev')}
            style={{ textAlign: 'right' }}
          >
            PREVISIÓN
          </Accordion.Toggle>
        </Col>
        <Accordion.Collapse eventKey="0">
          <Card.Body className="personal-data">
            {pensionScheme === 'afp' && (
              <Row className="mt-3">
                <Col md={3}>
                  <div className="d-flex flex-column mb-3">
                    <span className="type">Régimen Previsional:</span>
                    <span className={`answer ${!translatedPensionScheme ? 'text-grey' : ''}`}>
                      {translatedPensionScheme || 'No Aplica'}
                    </span>
                  </div>
                  <div className="d-flex flex-column mb-3">
                    <span className="type">AFP:</span>
                    <span className={`answer ${!pensionFund?.name ? 'text-grey' : ''}`}>
                      {pensionFund?.name || 'No Aplica'}
                    </span>
                  </div>
                </Col>

                <Col md={3}>
                  <div className="d-flex flex-column mb-3">
                    <span className="type">Fecha de Afiliación:</span>
                    <span className={`answer ${!pensionAffiliationDate ? 'text-grey' : ''}`}>
                      {pensionAffiliationDate || 'No Aplica'}
                    </span>
                  </div>
                </Col>

                <Col md={3}>
                  <div className="d-flex flex-column mb-3">
                    <span className="type">Tipo de Trabajador:</span>
                    <span className={`answer ${!translatedPensioner ? 'text-grey' : ''}`}>
                      {translatedPensioner || 'No Aplica'}
                    </span>
                  </div>
                </Col>

                <Col md={3}>
                  <div className="d-flex flex-column mb-3">
                    <span className="type">¿Pensionado por Vejez?:</span>
                    <span className={`answer ${!translatedIsOldAge ? 'text-grey' : ''}`}>
                      {translatedIsOldAge || 'No Aplica'}
                    </span>
                  </div>
                </Col>
              </Row>
            )}
            {pensionScheme === 'not_listed' && (
              <Row className="mt-3">
                <Col md={3}>
                  <div className="d-flex flex-column mb-3">
                    <span className="type">Régimen Previsional:</span>
                    <span className="answer">No cotiza</span>
                  </div>
                </Col>

                <Col md={3}>
                  <div className="d-flex flex-column mb-3">
                    <span className="type">Tipo de Trabajador:</span>
                    <span className={`answer ${!translatedPensioner ? 'text-grey' : ''}`}>
                      {translatedPensioner || 'No Aplica'}
                    </span>
                  </div>
                </Col>

                <Col md={3}>
                  <div className="d-flex flex-column mb-3">
                    <span className="type">¿Pensionado por Vejez?:</span>
                    <span className={`answer ${!translatedIsOldAge ? 'text-grey' : ''}`}>
                      {translatedIsOldAge || 'No Aplica'}
                    </span>
                  </div>
                </Col>

                <Col md={3}>{/* */}</Col>
              </Row>
            )}
            {pensionScheme === 'ips' && (
              <>
                <Row className="mt-3">
                  <Col md={3}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">Régimen Previsional:</span>
                      <span className="answer">IPS (ex INP)</span>
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">Fondo de Cotización:</span>
                      <span className={`answer ${!translatedIpsType ? 'text-grey' : ''}`}>
                        {translatedIpsType || 'No Aplica'}
                      </span>
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">Tasa Régimen General:</span>
                      <span className={`answer ${!parsedPensionSchemeRate ? 'text-grey' : ''}`}>
                        {parsedPensionSchemeRate || 'No Aplica'}
                      </span>
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">Tasa cot. Desahucio Ex-Regímen:</span>
                      <span className={`answer ${!parsedEvictionContributionRate ? 'text-grey' : ''}`}>
                        {parsedEvictionContributionRate || 'No Aplica'}
                      </span>
                    </div>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md={3}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">Tipo de Trabajador:</span>
                      <span className={`answer ${!translatedPensioner ? 'text-grey' : ''}`}>
                        {translatedPensioner || 'No Aplica'}
                      </span>
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">¿Pensionado por Vejez?:</span>
                      <span className={`answer ${!translatedIsOldAge ? 'text-grey' : ''}`}>
                        {translatedIsOldAge || 'No Aplica'}
                      </span>
                    </div>
                  </Col>
                </Row>
              </>
            )}
            <Row className="mt-3">
              <Col md={3}>
                <div className="d-flex flex-column mb-3">
                  <span className="type">Salud:</span>
                  <span className={`answer ${!healthPrevision?.name ? 'text-grey' : ''}`}>
                    {healthPrevision?.name || 'No Aplica'}
                  </span>
                </div>
              </Col>
              <Col md={3}>
                <div className="d-flex flex-column mb-3">
                  <span className="type">FUN:</span>
                  <span className={`answer ${!fun ? 'text-grey' : ''}`}>{fun || 'No Aplica'}</span>
                </div>
              </Col>
              <Col md={3}>
                <div className="d-flex flex-column mb-3">
                  <span className="type">Unidad de pago:</span>
                  <span className={`answer ${!translatedUnitOfAccount ? 'text-grey' : ''}`}>
                    {translatedUnitOfAccount || 'No Aplica'}
                  </span>
                </div>
              </Col>
              <Col md={3}>
                <div className="d-flex flex-column mb-3">
                  <span className="type">Cantidad Acordada:</span>
                  <span className={`answer ${!parsedAgreedQuantity ? 'text-grey' : ''}`}>
                    {parsedAgreedQuantity || 'No Aplica'}
                  </span>
                </div>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md={3}>
                <div className="d-flex flex-column mb-3">
                  <span className="type">T.E Exención Cotización:</span>
                  <span className={`answer ${youthAllowance == null ? 'text-grey' : ''}`}>
                    {yesNo(youthAllowance) || 'No Aplica'}
                  </span>
                </div>
              </Col>
              <Col md={3}>
                <div className="d-flex flex-column mb-3">
                  <span className="type">Adscripción Seg. Cesantía:</span>
                  <span className={`answer ${unemploymentInsurance == null ? 'text-grey' : ''}`}>
                    {yesNo(unemploymentInsurance) || 'No Aplica'}
                  </span>
                </div>
              </Col>
              <Col md={3}>
                <div className="d-flex flex-column mb-3">
                  <span className="type">Discapacidad:</span>
                  <span className={`answer ${translatedDisability === null ? 'text-grey' : ''}`}>
                    {translatedDisability || 'No Aplica'}
                  </span>
                </div>
              </Col>
              <Col md={2}>
                <div className="d-flex flex-column mb-3">
                  <span className="type">N° Credencial Discapacidad:</span>
                  <span className={`answer ${!disabilityNationalIdentification ? 'text-grey' : ''}`}>
                    {disabilityNationalIdentification || 'No Aplica'}
                  </span>
                </div>
              </Col>
              <Col md={1}>
                {disability && disability !== 'no_disability' && disabilityFileInfo && (
                  <div className="d-flex flex-column mb-3">
                    <span className="type">Certificado:</span>
                    <span className="answer">
                      <a
                        target="_blank"
                        className="font-weight-bold underline"
                        rel="noopener noreferrer"
                        href={disabilityFileInfo?.fileUrl || ''}
                      >
                        {disabilityFileInfo?.filename}
                      </a>
                    </span>
                  </div>
                )}
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md={3}>
                <div className="d-flex flex-column mb-3">
                  <span className="type">Subsidio al Empleo Joven:</span>
                  <span className={`answer ${youthAllowance == null ? 'text-grey' : ''}`}>
                    {yesNo(youthAllowance) || 'No Aplica'}
                  </span>
                </div>
              </Col>
              <Col md={3}>
                <div className="d-flex flex-column mb-3">
                  <span className="type">Trabajo Pesado:</span>
                  <span className={`answer ${!translatedHeavyLaborAdditional ? 'text-grey' : ''}`}>
                    {translatedHeavyLaborAdditional || 'No Aplica'}
                  </span>
                </div>
              </Col>
              <Col md={3}>
                <div className="d-flex flex-column mb-3">
                  <span className="type">Puesto Trabajo Pesado:</span>
                  <span className={`answer ${!heavyLaborStation ? 'text-grey' : ''}`}>
                    {heavyLaborStation || 'No Aplica'}
                  </span>
                </div>
              </Col>
              <Col md={3}>
                <div className="d-flex flex-column mb-3">
                  <span className="type">Código INE:</span>
                  <span className={`answer ${!translatedIneCode ? 'text-grey' : ''}`}>
                    {translatedIneCode || 'No Aplica'}
                  </span>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Accordion.Collapse>
      </Card>

      <Card className="mt-3 ml-2 mr-2">
        <Col className={`${activeKey === 'voluntaryContribution' ? 'top-header-green' : 'top-header-light-gray'} br-5`}>
          <Accordion.Toggle
            as={Col}
            eventKey="1"
            onClick={() => setKey('voluntaryContribution')}
            className="card-header-title"
            style={{ textAlign: 'right' }}
          >
            COTIZACIÓN VOLUNTARIA
          </Accordion.Toggle>
        </Col>
        <Accordion.Collapse eventKey="1">
          <Card.Body className="personal-data">{voluntaryPrevisions}</Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};

export default EmployeePrevisionInfo;
